import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { BaseModel } from '../models'
import { ModelFactory } from '../data/factories/index'
import { ModelRepository } from './model-repository'

interface IDelayStoreData {
  model: BaseModel, request: Observable<BaseModel>, status: string
}

interface IDelayStore {
  string: {status: string, data: IDelayStoreData[]}
}

interface IReplayStoreData {
  model: BaseModel, request: Observable<BaseModel>
}

interface IReplayStore {
  string: IReplayStoreData[]
}

@Injectable()
export class ModelRepositoryMock  {

  private static ID_COUNT = 1
  private _saveDelayStore: IDelayStore | {}
  private _deleteDelayStore: IDelayStore | {}
  private _saveReplay: IReplayStore | {}

  constructor(private _modelFactory?: ModelFactory) {}

  public findModelById(type: string, id: number, includeRelations: string[] = []): Observable<BaseModel> {
    return null
  }

  public findAllModels(type: string, includeRelations: string[] = []): Observable<BaseModel[]> {
    return Observable.of([])
  }

  public findModelsBy(type: string, searchCriteria: any, includeRelations: string[] = []): Observable<BaseModel[]> {
    return Observable.of([])
  }

  public save(model: BaseModel): Observable<BaseModel> {
    model.id = '' + ModelRepositoryMock.ID_COUNT++
    model['_persisted'] = true
    return Observable.of(model)
  }

  public delete(model: BaseModel): Observable<BaseModel> {
    return Observable.of(model)
  }

  public initialize(initClassesSpec: any[]): void {

  }

  public createModel(type: string, properties: {[key: string]: any}) {
    if (this._modelFactory) {
      return this._modelFactory.createAndInitialize(type, properties)
    }

    throw new Error('ModelRepositoryMock#createModel: Provide a ModelFactory in the constructor of '
                  + 'ModelRepositoryMock to use createModel.')
  }

  public reset(): void {

  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/model-repository.mock.ts